import { render, staticRenderFns } from "./dashboard-employee.vue?vue&type=template&id=37ed7094&"
import script from "./dashboard-employee.vue.ts?vue&type=script&lang=ts&"
export * from "./dashboard-employee.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports